module.exports = __webpack_public_path__ + "static/img/112.8cf26ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/112.png
// module id = lzWx
// module chunks = 0